module.exports = __webpack_public_path__ + "static/media/madofuki.847bf208.png";